const SERVER_API = 'https://transport-backend.shreegrgoilmill.com/public/api';
export{SERVER_API};
const PUSHER_API = 'https://transport-backend.shreegrgoilmill.com/public/broadcasting/auth' 
export{PUSHER_API};
const PUSHER_KEY = 'ae7f879a57884f61cc77'
export{PUSHER_KEY};